import { parseNameParts } from '../parse';
import { SelectionNamePhonetization, SelectionNameRomanization, SelectionNamePieces } from './internal';
export class SelectionName extends SelectionNamePieces {
    valueAsParts() {
        return this.value().map(parseNameParts);
    }
    getType() {
        return this.get("TYPE" /* Tag.Type */);
    }
    getNamePhonetization() {
        return this.get("FONE" /* Tag.Phonetic */, null, SelectionNamePhonetization);
    }
    getNameRomanization() {
        return this.get("FONE" /* Tag.Phonetic */, null, SelectionNameRomanization);
    }
}
//# sourceMappingURL=SelectionName.js.map